// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2O_xR","notes":"Notes_notes__33uDC","note":"Notes_note__1Tg8U","markdown":"Notes_markdown__2EsN1"};